<template>
  <v-form :name="searchProps.formName" @keyup.enter="autoSearch = true">
    <Tabs value="0" scrollable>

      <TabList class="mb-4">
        <Tab value="0">{{ __('Search condition') }}</Tab>
      </TabList>

      <TabPanels>
        <TabPanel value="0">
          <div class="grid">
            <FormInputText fieldName="user" label="User" size="4" v-model:field="search.user" />

            <FormCalendar fieldName="date_from" label="Date from" size="4" v-model:field="search.created_at_from" />

            <FormCalendar fieldName="date_to" label="Date to" size="4" v-model:field="search.created_at_to" />
          </div>
          <div class="grid">
            <FormInputText fieldName="email" label="Email" size="4" v-model:field="search.email" />

            <FormInputText fieldName="subject" label="Subject" size="4" v-model:field="search.subject" />

            <FormInputText fieldName="body" label="Body" size="4" v-model:field="search.body" />
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>


    <div class="grid">
      <SearchButtons :searchProps="searchProps" :search="search" v-model:autoSearch="autoSearch" />
    </div>
  </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
  searchProps: Object,
})

const autoSearch = ref(false)

let search = ref({})
prepareSearch(search, props)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
